import { useState } from "react";
import { CompanyInfoSection } from "./form/CompanyInfoSection";
import { ContactInfoSection } from "./form/ContactInfoSection";
import { DomainManagement } from "./form/DomainManagement";
import { FormActions } from "./form/FormActions";
import { CompanyFormData } from "./form/types";

export type { CompanyFormData } from "./form/types";

interface CompanyFormProps {
  initialData: CompanyFormData;
  onSubmit: (data: CompanyFormData) => void;
  onCancel: () => void;
  submitLabel: string;
  isSubmitting?: boolean;
}

export const CompanyForm = ({ 
  initialData, 
  onSubmit, 
  onCancel, 
  submitLabel,
  isSubmitting = false
}: CompanyFormProps) => {
  const [formData, setFormData] = useState<CompanyFormData>(initialData);
  
  const handleChange = (key: keyof CompanyFormData, value: string) => {
    setFormData({
      ...formData,
      [key]: value
    });
  };

  const handleDomainsChange = (domains: string[]) => {
    setFormData({
      ...formData,
      domains
    });
  };
  
  const handleSubmit = () => {
    if (!formData.name) {
      alert("Company name is required");
      return;
    }
    
    if (!formData.contact_email) {
      alert("Contact email is required");
      return;
    }
    
    onSubmit(formData);
  };
  
  return (
    <div className="space-y-4">
      <div className="space-y-4">
        {/* Company Information */}
        <CompanyInfoSection 
          name={formData.name} 
          onChange={handleChange} 
        />

        {/* Contact Information */}
        <ContactInfoSection 
          contactPerson={formData.contact_person}
          contactEmail={formData.contact_email}
          contactRole={formData.contact_role}
          contactPassword={formData.contact_password}
          contactPhone={formData.contact_phone}
          address={formData.address}
          onChange={handleChange}
        />
        
        {/* Domain Management */}
        <DomainManagement 
          domains={formData.domains}
          onDomainsChange={handleDomainsChange}
        />
      </div>
      
      {/* Form Actions */}
      <FormActions 
        onCancel={onCancel}
        onSubmit={handleSubmit}
        submitLabel={submitLabel}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};
